import 'react-loading-skeleton/dist/skeleton.css';

import Skeleton from 'react-loading-skeleton';

export default function SkeletonMemulList() {
  return (
    <div className="memul_list_item">
      <a className="clickable">
        <div className="tag_div">
          <Skeleton width={40} height={18} />
        </div>
        <div className="item_detail d_flex">
          <div className="item_info flex1">
            <div className="price_info">
              <Skeleton width={228} height={24} />
            </div>
            <Skeleton width={120} height={12} />
            <div style={{ lineHeight: 0.6 }}>
              <Skeleton width={167} height={4} />
              <Skeleton width={228} height={4} />
              <Skeleton width={110} height={4} />
              <Skeleton width={140} height={4} />
            </div>
          </div>
          <Skeleton className="item_photo" width={84} height={92} />
        </div>
      </a>
    </div>
  );
}
